/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Exp_HighlightInputs */

const en_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledger`)
};

const ar_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الزمني`)
};

const bn_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অভিজ্ঞতা`)
};

const de_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const es_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro`)
};

const fr_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chronologique`)
};

const pt_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cronológico`)
};

const zh_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类账`)
};

const tr_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defter`)
};

const ru_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Леджер`)
};

const pl_heading_exp_highlight = /** @type {(inputs: Heading_Exp_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Księga rachunkowa`)
};

/**
* | output |
* | --- |
* | "Ledger" |
*
* @param {Heading_Exp_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_exp_highlight = /** @type {((inputs?: Heading_Exp_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Exp_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_exp_highlight(inputs)
	if (locale === "bn") return bn_heading_exp_highlight(inputs)
	if (locale === "de") return de_heading_exp_highlight(inputs)
	if (locale === "es") return es_heading_exp_highlight(inputs)
	if (locale === "fr") return fr_heading_exp_highlight(inputs)
	if (locale === "pt") return pt_heading_exp_highlight(inputs)
	if (locale === "zh") return zh_heading_exp_highlight(inputs)
	if (locale === "tr") return tr_heading_exp_highlight(inputs)
	if (locale === "ru") return ru_heading_exp_highlight(inputs)
	if (locale === "pl") return pl_heading_exp_highlight(inputs)
	return en_heading_exp_highlight(inputs)
});